// profile/mutations.ts
import Vue from 'vue';
import { MutationTree } from 'vuex';
import {CommentQue, FAQ, RateState, ReviewRate} from './types';
import {User} from 'firebase';
import * as firebase from 'firebase';
import DocumentReference = firebase.firestore.DocumentReference;
import {Lookup} from '@/store/types';
import {MAFUser} from '@/store/User/types';

export const mutations: MutationTree<RateState> = {
    setReviews(state, payload: ReviewRate[] | undefined): void {
        if (state) {
            state.reviewRate = payload;

        }
    },
    setComments(state, payload: CommentQue[] | undefined): void {
        if (state) {
            state.commentsQues = payload ;
        }
    },
    setFAQ(state, payload: FAQ[] ) {
        if (state) {
            state.faqs = payload;
        }
    },
};
